import { CustomBreadcrumb, PageContent } from "components/Common";
import { ModuleIds } from "constant";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import InstrumentConfig from "./InstrumentConfig";

const RESOURCE = ModuleIds.Instrument
const InstrumentConfigContainer = ({ t }) => {
    const titleTag = `Instruments`
    return (
        <PageContent title={titleTag}>
            <CustomBreadcrumb
                breadcrumbItem={t("Instrument")}
                resource={RESOURCE}
            />
            <InstrumentConfig />
        </PageContent>
    );
}

InstrumentConfigContainer.propTypes = {
    t: PropTypes.any,
}

export default withTranslation(["machinePage"])(InstrumentConfigContainer)